import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Flex from '@magalu/stereo-ui/atoms/Flex';
export var Box = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));